(function() {
  'use strict';

  var STORAGE_SESSION = 'valliani-newsletter-popup-session';
  var STORAGE_DONE = 'valliani-newsletter-popup-completed';
  var STORAGE_EXPIRY = 'vj-newsletter-popup-expiry';
  var openTimer = null;

  function root() {
    return document.getElementById('vj-newsletter-popup');
  }

  function overlay() {
    return document.getElementById('PopupOverlay');
  }

  function modal() {
    var el = root();
    return el ? el.querySelector('.vj-newsletter-modal') : null;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // PageSpeed / Lighthouse / bots — never open (late modal image becomes fake 10–20s LCP)
  function isPerfLab() {
    try {
      if (navigator.webdriver) return true;
      var ua = navigator.userAgent || '';
      if (/Chrome-Lighthouse|PageSpeed|PTST|GTmetrix|Lighthouse|HeadlessChrome/i.test(ua)) return true;
    } catch (e) {}
    return false;
  }

  function clearOpenTimer() {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }
  }

  function markDismissed() {
    try {
      sessionStorage.setItem(STORAGE_SESSION, '1');
    } catch (e) {}
  }

  function hideUi() {
    var el = root();
    var m = modal();
    var o = overlay();

    if (el) {
      el.dataset.vjDismissed = '1';
      el.setAttribute('data-vj-dismissed', '1');
      el.classList.remove('vj-is-open');
    }

    if (m) {
      m.hidden = true;
      m.setAttribute('hidden', '');
      m.style.display = 'none';
    }

    if (o) {
      o.hidden = true;
      o.setAttribute('hidden', '');
      o.setAttribute('aria-hidden', 'true');
      o.style.display = 'none';
    }

    document.body.classList.remove('vj-newsletter-open', 'fullscreen-popup-open');
    try {
      document.documentElement.style.removeProperty('--vj-scrollbar-comp');
    } catch (e) {}
  }

  function markSubscribed() {
    clearOpenTimer();

    try {
      localStorage.setItem(STORAGE_DONE, '1');
      localStorage.removeItem(STORAGE_EXPIRY);
      sessionStorage.removeItem(STORAGE_SESSION);
      sessionStorage.removeItem('valliani-newsletter-popup-shown-session');
      sessionStorage.removeItem('valliani-newsletter-popup-pending');
    } catch (e) {}

    var el = root();
    if (el) {
      el.dataset.vjSubscribed = '1';
      el.setAttribute('data-vj-subscribed', '1');
    }

    hideUi();
  }

  function setExpiry(days) {
    try {
      var d = days > 0 ? days : 7;
      var expiry = new Date(Date.now() + d * 24 * 60 * 60 * 1000);
      localStorage.setItem(STORAGE_EXPIRY, JSON.stringify({ expiry: expiry.toISOString() }));
    } catch (e) {}
  }

  function isDismissedThisSession() {
    try {
      return sessionStorage.getItem(STORAGE_SESSION) === '1';
    } catch (e) {
      return false;
    }
  }

  function isCompleted() {
    try {
      return localStorage.getItem(STORAGE_DONE) === '1';
    } catch (e) {
      return false;
    }
  }

  function isExpiredOrNotSet() {
    try {
      var raw = localStorage.getItem(STORAGE_EXPIRY);
      if (!raw) return true;
      var expiry = Date.parse(JSON.parse(raw).expiry);
      return expiry <= Date.now();
    } catch (e) {
      return true;
    }
  }

  function clearBlockersForTestMode() {
    try {
      sessionStorage.removeItem(STORAGE_SESSION);
      localStorage.removeItem(STORAGE_EXPIRY);
      // Do NOT clear STORAGE_DONE — subscribed users stay hidden
    } catch (e) {}
  }

  function shouldShow() {
    var el = root();
    if (!el) return false;

    var enabled = el.dataset.popupEnabled === 'true';
    var testMode = el.dataset.popupTestMode === 'true';
    if (!enabled && !testMode) return false;

    // Already subscribed → never show (even in test / design mode)
    if (isCompleted()) return false;
    if (el.dataset.vjSubscribed === '1' || el.getAttribute('data-vj-subscribed') === '1') return false;
    if (el.dataset.popupCustomerSubscribed === 'true') {
      markSubscribed();
      return false;
    }
    if (el.querySelector('[data-vj-popup-subscribed="1"]')) {
      markSubscribed();
      return false;
    }
    if (window.location.search && /[?&]newsletter_popup_ok=1(?:&|$)/.test(window.location.search)) {
      markSubscribed();
      return false;
    }

    if (testMode) {
      clearBlockersForTestMode();
      el.dataset.vjDismissed = '';
      return true;
    }

    if (isDesignMode() && enabled) {
      el.dataset.vjDismissed = '';
      return true;
    }

    if (el.dataset.vjDismissed === '1') return false;
    if (isDismissedThisSession()) return false;
    if (!isExpiredOrNotSet()) return false;
    return true;
  }

  function openPopup() {
    var el = root();
    var m = modal();
    if (!el || !m) return;
    if (isCompleted()) return;
    if (el.dataset.vjDismissed === '1' || el.dataset.vjSubscribed === '1') return;
    if (el.querySelector('[data-vj-popup-subscribed="1"]')) {
      markSubscribed();
      return;
    }

    // Compensate scrollbar width before lock — prevents desktop CLS ~0.2+
    try {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      if (sb > 0) {
        document.documentElement.style.setProperty('--vj-scrollbar-comp', sb + 'px');
      }
    } catch (e) {}

    // Hydrate deferred banner images only when opening
    m.querySelectorAll('[data-vj-src]').forEach(function (img) {
      if (!img.getAttribute('src') && img.getAttribute('data-vj-src')) {
        img.setAttribute('src', img.getAttribute('data-vj-src'));
      }
      if (!img.getAttribute('srcset') && img.getAttribute('data-vj-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-vj-srcset'));
      }
    });
    m.querySelectorAll('source[data-vj-srcset]').forEach(function (source) {
      if (!source.getAttribute('srcset')) {
        source.setAttribute('srcset', source.getAttribute('data-vj-srcset'));
      }
    });

    m.style.display = '';
    m.removeAttribute('hidden');
    m.hidden = false;
    el.classList.add('vj-is-open');
    document.body.classList.add('vj-newsletter-open');

    var o = overlay();
    if (o) {
      o.style.display = '';
      o.removeAttribute('hidden');
      o.hidden = false;
      o.setAttribute('aria-hidden', 'false');
    }

    var email = m.querySelector('[id^="PopupEmail-"]');
    if (email) setTimeout(function() { email.focus({ preventScroll: true }); }, 400);
  }

  function closePopup() {
    var el = root();
    if (!el) return;

    clearOpenTimer();
    markDismissed();
    hideUi();

    if (el.dataset.popupTestMode !== 'true') {
      var days = parseInt(el.dataset.popupTime, 10);
      setExpiry(days);
    }
  }

  function onDocumentClick(e) {
    var el = root();
    if (!el || !el.classList.contains('vj-is-open')) return;

    if (e.target.closest('[data-vj-popup-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
      return;
    }

    if (e.target.id === 'PopupOverlay') {
      closePopup();
    }
  }

  function bindFormSubmit() {
    var el = root();
    if (!el) return;
    var form = el.querySelector('form.vj-popup-form__form');
    if (!form || form.dataset.vjSubscribeBound === '1') return;
    form.dataset.vjSubscribeBound = '1';

    form.addEventListener('submit', function () {
      try {
        sessionStorage.setItem('valliani-newsletter-popup-pending', '1');
        localStorage.setItem(STORAGE_DONE, '1');
        localStorage.removeItem(STORAGE_EXPIRY);
      } catch (e) {}
      markSubscribed();
    });
  }

  function bindEvents() {
    if (document.documentElement.dataset.vjPopupBound === '1') return;
    document.documentElement.dataset.vjPopupBound = '1';

    document.addEventListener('click', onDocumentClick, true);

    document.addEventListener('keydown', function(e) {
      var el = root();
      if (e.key === 'Escape' && el && el.classList.contains('vj-is-open')) {
        closePopup();
      }
    });
  }

  function init() {
    var el = root();
    if (!el) return;

    bindEvents();
    bindFormSubmit();
    clearOpenTimer();

    // Success redirect / already subscribed → permanent hide, never open
    if (window.location.search && /[?&]newsletter_popup_ok=1(?:&|$)/.test(window.location.search)) {
      markSubscribed();
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('newsletter_popup_ok');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
      return;
    }

    if (el.querySelector('[data-vj-popup-subscribed="1"]')) {
      markSubscribed();
      return;
    }

    if (isCompleted()) {
      markSubscribed();
      return;
    }

    try {
      if (sessionStorage.getItem('valliani-newsletter-popup-pending') === '1') {
        sessionStorage.removeItem('valliani-newsletter-popup-pending');
        if (isCompleted()) {
          markSubscribed();
          return;
        }
      }
    } catch (e) {}

    if (!shouldShow()) return;

    // Lab tools never see the popup (keeps LCP on the real hero)
    if (isPerfLab() && el.dataset.popupTestMode !== 'true' && !isDesignMode()) {
      return;
    }

    el.dataset.vjDismissed = '';
    el.removeAttribute('data-vj-dismissed');

    var delaySec = parseInt(el.dataset.popupDelay, 10);
    if (isNaN(delaySec) || delaySec < 0) delaySec = 8;
    if (el.dataset.popupTestMode !== 'true' && !isDesignMode() && delaySec < 8) {
      delaySec = 8;
    }
    var delayMs = (el.dataset.popupTestMode === 'true' || isDesignMode()) ? 400 : delaySec * 1000;
    var armed = false;

    function scheduleOpen() {
      if (armed) return;
      armed = true;
      clearOpenTimer();
      var start = Date.now();
      function tryOpen() {
        openTimer = null;
        if (isCompleted() || !shouldShow()) return;
        var waited = Date.now() - start;
        var remain = delayMs - waited;
        if (remain > 50) {
          openTimer = setTimeout(tryOpen, remain);
          return;
        }
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function () {
            if (!isCompleted() && shouldShow()) openPopup();
          }, { timeout: 1500 });
        } else if (!isCompleted() && shouldShow()) {
          openPopup();
        }
      }
      openTimer = setTimeout(tryOpen, delayMs);
    }

    if (el.dataset.popupTestMode === 'true' || isDesignMode()) {
      scheduleOpen();
      return;
    }

    // Real users: only after scroll (PSI doesn't scroll → no popup → no fake LCP).
    // Fallback 45s if they never scroll.
    var scrolled = false;
    function onEngage() {
      if (scrolled) return;
      scrolled = true;
      scheduleOpen();
    }
    window.addEventListener('scroll', onEngage, { once: true, passive: true });
    window.addEventListener('touchstart', onEngage, { once: true, passive: true });
    window.addEventListener('keydown', onEngage, { once: true, passive: true });
    setTimeout(function () {
      if (!armed && shouldShow()) scheduleOpen();
    }, 45000);
  }

  window.VjNewsletterPopup = {
    open: openPopup,
    close: closePopup,
    markSubscribed: markSubscribed
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
